import { getAxiosInstance } from '../../../../np-rest/rest';
import { snackActions } from '../../../../sc-utilities/SnackBar';

export const fetchErasureReportCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            let countRes = await rest.post("/report/count", filterData, { cancelToken: options.countSource.token });
            if (countRes.data && countRes.data.succeeded) {
                return { data: countRes.data.result.data }
            }
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch erasure report."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch erasure report."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
};

export const fetchErasureReport = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let listRes = await rest.post("/report/list", filterData, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                return { data: listRes.data.result.data };
            }
            return { data: [] };
        }
        catch (error) {
            return { data: [] };
        }
    }
};

export const fetchDiagnoseReportCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();

    return async () => {
        try {
            let countRes = await rest.post("/report/count-diagnose", filterData, { cancelToken: options.countSource.token });
            if (countRes.data && countRes.data.succeeded) {
                return { data: countRes.data.result.data }
            }
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch erasure report."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch erasure report."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
};

export const fetchDiagnoseReport = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let listRes = await rest.post("/report/list-diagnose", filterData, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                return { data: listRes.data.result.data };
            }
            return { data: [] };
        }
        catch (error) {
            return { data: [] };
        }
    }
};

export const regenerateErasureReport = (data) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let result = await rest.post("/report/re-generate", data);
            if (result.data && result.data.succeeded) {
                return { data: result };
            }
            snackActions.snackBar({
                message: `${result.data ? result.data.message : result.message}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: null };
        }
        catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: null };
        }
    }
}
export const listProductTypes = (params, options) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/product-type/list', params, options);
            if (res.data && res.data.succeeded) {
                const productTypes = [];
                for (var productType of res.data.result.data) {
                    productTypes.push({
                        value: `${productType.ProductTypeID}`,
                        label: `${productType.Name}`,
                        key: `${productType.Key}`
                    });
                }
                return productTypes.sort((a, b) => a.label.localeCompare(b.label));
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};